import React, { useState } from "react";
import { BiMenu, BiX } from "react-icons/bi";
import { FaCircleUser } from "react-icons/fa6";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useUser } from "../context/UserContext";
import { logoutUser } from "../services/LogoutServices";
import CustomModal from "./UI/CustomModal";

const navItems = [
  {
    name: "Home",
    to: "/",
    needsLogin: false
  },
  {
    name: "Dashboard",
    to: "/dashboard",
    needsLogin: true
  },
  {
    name: "Resources",
    to: "/resources",
    needsLogin: false
  },
  {
    name: "About",
    to: "/about",
    needsLogin: false
  },
  {
    name: "Contact Us",
    to: "/contact",
    needsLogin: false
  },
];

const DesktopViewForNavigation = ({ signOut }) => (
  <div
    className="hidden group-hover:block absolute duration-200 z-10 w-48 origin-top-right rounded-md bg-primary text-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    tabIndex="-1"
  >
    <div className="py-1" role="none">
      <Link
        to="/profile"
        className="hover:text-secondary block px-4 py-2 text-sm"
        role="menuitem"
        tabIndex="-1"
        id="menu-item-1"
      >
        Profile
      </Link>
      <Link
        to="/"
        className="hover:text-secondary block px-4 py-2 text-sm"
        role="menuitem"
        tabIndex="-1"
        id="menu-item-1"
        onClick={(e) => signOut(e)}
      >
        Sign out
      </Link>
    </div>
  </div>
);

const MobileViewForNavigation = ({ signOut }) => (
  <div className="py-1" role="none">
    <Link
      to="/dashboard"
      className="hover:text-secondary block px-4 py-2 text-sm"
      role="menuitem"
      tabIndex="-1"
      id="menu-item-0"
    >
      Dashboard
    </Link>
    <Link
      to="/profile"
      className="hover:text-secondary block px-4 py-2 text-sm"
      role="menuitem"
      tabIndex="-1"
      id="menu-item-1"
    >
      Profile
    </Link>
    <Link
      to="/"
      className="hover:text-secondary block px-4 py-2 text-sm"
      role="menuitem"
      tabIndex="-1"
      id="menu-item-1"
      onClick={(e) => signOut(e)}
    >
      Sign out
    </Link>
  </div>
);

const Nav = () => {
  const navigate = useNavigate();

  const { userInfo, isNewUser } = useUser();

  const { user_email, first_name, last_name } = userInfo;
  const { isLoggedIn, onLogout } = useAuth();

  const [mobileView, setMobileView] = useState(window.innerWidth <= 1022);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [modal, setModal] = useState();

  window.addEventListener("resize", () =>
    setMobileView(window.innerWidth < 1022)
  );
  const handleNav = () => setShowHamburgerMenu((prev) => !prev);

  const signOut = async (event) => {
    event.preventDefault();
    if (!user_email) {
      setModal({
        title: "Context Issue",
        message: "We were unable to fetch your email. Please try again.",
        type: "error",
      });
      return;
    }
    const response = await logoutUser(user_email);
    if (response.status === 0) {
      onLogout();
      sessionStorage.clear();
      localStorage.clear();
      navigate("/");
    } else {
      setModal({
        title: response.title,
        message: response.message,
        type: "error",
      });
    }
  };

  return (
    <>
      {modal && (
        <CustomModal
          title={modal.title}
          message={modal.message}
          onConfirm={() => setModal(null)}
          type={modal.type}
        />
      )}
      <div className="main-container">
        <div className="content-container py-[5px] px-[10px] sm:px-[50px] md:px-[100px]">
          <nav className="flex flex-wrap items-center justify-between w-full py-4 md:py-0">
            <Link to="/" className="hover:text-secondary lg:hidden block">
              <img
                src="/pfas-logo-hrz-color.svg"
                alt="PFAS logo horizontal"
                className="h-[60px]"
              />
            </Link>

            {showHamburgerMenu ? (
              <BiX
                onClick={handleNav}
                className="mr-4 text-primary hover:text-secondary h-6 w-6 cursor-pointer lg:hidden block"
              />
            ) : (
              <BiMenu
                onClick={handleNav}
                className="mr-4 text-primary hover:text-secondary h-6 w-6 cursor-pointer lg:hidden block"
              />
            )}

            <div
              className={`${
                showHamburgerMenu ? "" : "hidden"
              } w-full lg:flex-1 lg:flex lg:items-center lg:w-auto pb-4`}
              id="menu"
            >
              <ul className="w-full pt-4 text-base font-medium text-primary lg:flex lg:justify-between lg:pt-0">
                <li className="lg:block hidden">
                  <Link to="/">
                    <img
                      src="/pfas-logo-hrz-color.svg"
                      alt="PFAS logo horizontal"
                      className="h-[60px]"
                    />
                  </Link>
                </li>
                {navItems.map((item) => (
                  ( item.needsLogin && !isLoggedIn ) ? null : (
                    <li key={item.name}>
                      <NavLink
                        className={({ isActive }) =>
                          `${
                          isActive ? "text-secondary " : ""
                        } hover:text-secondary md:py-4 py-2 block`
                      }
                        to={item.to}
                        end
                      >
                      {item.name}
                      </NavLink>
                    </li>
                  )
                ))}
                <li>
                  {isLoggedIn ? (
                    isNewUser ? (
                      <Link
                        to="/"
                        className="hover:text-secondary md:py-4 py-2 block"
                        role="menuitem"
                        tabIndex="-1"
                        id="menu-item-1"
                        onClick={(e) => signOut(e)}
                      >
                        Sign out
                      </Link>
                    ) : (
                      <>
                        <div className="group relative inline-block text-left">
                          <span className="cursor-pointer md:py-4 py-2 flex items-center gap-2 hover:text-secondary">
                            {`${first_name ?? ""} ${last_name ?? ""}`}
                            <FaCircleUser className="text-xl" />
                          </span>
                          {mobileView && showHamburgerMenu ? (
                            <MobileViewForNavigation signOut={signOut} />
                          ) : (
                            <DesktopViewForNavigation signOut={signOut} />
                          )}
                        </div>
                      </>
                    )
                  ) : (
                    <Link
                      to="/signin"
                      className="md:py-4 py-2 flex items-center gap-2 hover:text-secondary"
                    >
                      Sign in <FaCircleUser className="text-xl" />
                    </Link>
                  )}
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Nav;
